import type { EChartsOption } from "echarts";
import EChartBase from "./EChartBase";
import { toneColor } from "./ChartTheme";

export type TreemapDatum = {
  label: string;
  value: number;
  tone?: string;
  [key: string]: any;
};

type Props = {
  data: TreemapDatum[];
  height?: number | string;
};

export default function TreemapChart({ data, height = 330 }: Props) {
  const option: EChartsOption = {
    tooltip: { formatter: "{b}: {c}" },
    series: [
      {
        type: "treemap",
        roam: false,
        breadcrumb: { show: false },
        label: { show: true, formatter: "{b}" },
        data: data.map((x) => ({
          name: x.label,
          value: x.value || 1,
          itemStyle: { color: toneColor(x.tone) },
          raw: x,
        })),
      },
    ],
  };

  return <EChartBase option={option} height={height} empty={!data?.length} />;
}